// React
import React, { FC, Fragment } from "react";

// Styles
import injectSheet from "react-jss";

interface Props {
  classes: any;
  lead: string;
  headers?: [];
  lists?: any;
  paging?: {
    position?: string;
    page: number;
    recordsPerPage: number;
    totalRecords: number;
    start?: number;
    end?: number;
    totalPages?: number;
  };
  pagingPrev: (direction?: number) => void;
  pagingNext: (direction?: number) => void;
  error?: any;
}

import styleSheet from "./styles";

// Components
import Card from "HOC/Card";
import { Paging } from "Components/Paging";
import { FormattedDate } from "Utils/formattedDate";

const rowHeadersHelper = (classes: any, headers: string[]) => (
  <div className={classes.row}>
    <div className={`${classes.column} ${classes.large}`}>
      <span className={`${classes.columnHeader}`}>{headers[0]}</span>
    </div>
    <div className={`${classes.column} ${classes.small}`}>
      <span className={`${classes.columnHeader} ${classes.center}`}>
        {headers[1]}
      </span>
    </div>
    <div className={`${classes.column} ${classes.small}`}>
      <span className={`${classes.columnHeader} ${classes.right}`}>
        {headers[2]}
      </span>
    </div>
  </div>
),
  listsHelper = (classes: any, lists: any) =>
    lists.map((list: any, index: number) => (
      <Fragment key={index}>
        <div className={`${classes.row} ${classes.verticalAlign}`}>
          <div className={`${classes.column} ${classes.large}`}>
            <span className={`${classes.text} ${classes.lowLineHeight}`}>
              {list.name}
            </span>
          </div>
          <div className={`${classes.column} ${classes.small}`}>
            <span
              className={`${classes.text} ${classes.lowLineHeight} ${classes.center}`}
            >
              {list.createUser}
            </span>
          </div>
          <div className={`${classes.column} ${classes.small}`}>
            <span
              className={`${classes.text} ${classes.highLineHeight} ${classes.right}`}
            >
              {FormattedDate(list.createdAt)}
            </span>
          </div>
        </div>
        {index === lists.length - 1 || <div className={classes.lineBreak} />}
      </Fragment>
    )),
  rendertableHelper = (classes: any, lists: any, headers: string[]) => (
    <>
      {rowHeadersHelper(classes, headers)}
      {listsHelper(classes, lists)}
    </>
  ),
  emptyState = (classes: any, lead: string) => (
    <div className={`${classes.noListsContainer}`}>
      <span className={`${classes.noListsText} ${classes.center}`}>
        {lead} is not on any list
      </span>
    </div>
  ),
  addPaging = (
    classes: any,
    paging: any,
    pagingPrev: (direction?: number) => void,
    pagingNext: (direction?: number) => void
  ) => (
      <div
        className={
          paging.totalRecords === paging.end && paging.start === 1
            ? classes.pagingContainerNoMoreRecords
            : classes.pagingContainerRecordsRemaining
        }
      >
        <Paging
          page={paging.page}
          recordsPerPage={paging.recordsPerPage}
          totalRecords={paging.totalRecords}
          prev={pagingPrev}
          next={pagingNext}
          position="right"
          parent={"List Membership"}
          totalPages={paging.totalPages}
        />
      </div>
    ),
  ListMembership: FC<Props> = ({
    classes,
    error,
    lists,
    lead,
    paging,
    pagingPrev,
    pagingNext,
    headers = ["List Name", "Created by", "Date Added"]
  }) => (
      <div
        className={`${classes.container}
    ${!lists || (lists && lists.length === 0) ? classes.noRecordsContainer : ""}
    `}
      >
        <Card
          error={error}
          title="List Membership"
          overrideStyles={{
            paddingTop: "23px",
            paddingRight: "0px",
            paddingBottom: "8.39px",
            paddingLeft: "32px"
          }}
        >
          <div className={classes.rightPaddedContainer}>
            {lists && lists.length > 0
              ? rendertableHelper(classes, lists, headers)
              : emptyState(classes, lead)}
          </div>
          {paging &&
            lists &&
            lists.length > 0 &&
            addPaging(classes, paging, pagingPrev, pagingNext)}
        </Card>
      </div>
    );

export default injectSheet(styleSheet)(ListMembership);
